// src/components/Dashboard/Dashboard.jsx
import React, { useState } from 'react';
import { AILegalResearcher } from '../services/AILegalResearcher/AILegalResearcher';
import MainLayout from '../Layout/MainLayout';

const Dashboard = () => {
  const [selectedTool, setSelectedTool] = useState('researcher');
  const [creditBalance] = useState(100);

  return (
    <MainLayout selectedTool={selectedTool} onSelectTool={setSelectedTool} creditBalance={creditBalance}>
      <div className="max-w-6xl mx-auto space-y-3 mt-1">
        {/* Active Tool Section */}
        {selectedTool === 'researcher' && (
          <div className="bg-white p-6 rounded-lg shadow">
            <AILegalResearcher />
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default Dashboard;